export default "__VITE_ASSET__xKkA1Lt7__"